<template>
  <v-app
    id="reset_password"
    class="brand_neutral"
  >
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
            lg4
          >
            <v-flex
              class="mb-5"
            >
              <v-img
                style="margin: 0 auto;"
                width="200px"
                src="/img/logo_light_no_top.png"
              />
            </v-flex>
            <v-card class="elevation-1 pa-3">
              <v-card-title class="text-xs-center">
                <h1 class="flex my-4 primary--text">
                  {{ $t('Commerce Console') }}
                </h1>

                <div class="absolute-right flag-login-position">
                  <language-switcher
                    flag-only
                    flag-size="24px"/>
                </div>
              </v-card-title>

              <v-card-text>
                <v-form>
                  <v-text-field
                    :error-count="errors.length"
                    :error-messages="errors"
                    v-model="password"
                    :label="$t('New Password')"
                    append-icon="lock"
                    name="password"
                    type="password"
                  />
                  <v-text-field
                    v-model="password_confirmation"
                    :label="$t('Password Confirmation')"
                    append-icon="lock"
                    name="password_confirmation"
                    type="password"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <router-link
                  :to="{
                    name: 'Login',
                  }"
                  class="pl-2"
                >
                  {{ $t('Remember password? Log In!') }}
                </router-link>
                <v-spacer/>
                <v-btn
                  :loading="loading"
                  color="primary"
                  @click="reset"
                >
                  {{ $t('Reset Password') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LanguageSwitcher from '../components/LanguageSwitcher'
import { mapGetters } from 'vuex'
import http from '../services/api/client'
import store from '../store'
import radio from '../plugins/bus'

export default {
  components: {
    LanguageSwitcher
  },

  data () {
    return {
      password: '',
      password_confirmation: '',
      errors: [],
      client: http(store, radio)
    }
  },

  computed: {
    ...mapGetters({
      loading: 'pagination/loading'
    })
  },

  watch: {
    password: function (val) {
      if (val) {
        this.errors = []
      }
    },

    password_confirmation: function (val) {
      if (val) {
        this.errors = []
      }
    }
  },

  methods: {
    reset () {
      this.client.request({
        url: 'auth/v1/users/password/reset/' + this.$route.params.token,
        method: 'PUT',
        data: {
          password: this.password,
          password_confirmation: this.password_confirmation
        },
        headers: {
          'x-user-type': 'admin'
        }
      }).then(() => {
        this.errors = []
        this.$toast(this.$t('Password changed. You can now log in.'))
        this.$router.replace({ name: 'Login' })
      }).catch(e => {
        if (e.response.status === 422) {
          this.errors = e.response.data.errors.password
        }

        this.$toast.error(this.$t(e.response.data.message))
      })
    }
  }
}
</script>

<style scoped lang="css">
#reset_password {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

a {
  text-decoration: none;
}
</style>
